function roleType(input, include) {
  const out = [];
  if (input && input.length) {
    input.forEach((item) => {
      let keep = false;
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const k in item.roles) {
        switch (include) {
          case 'pro':
            if (item.roles[k].role === 'manager' || item.roles[k].role === 'user') {
              keep = true;
            }
            break;
          case 'house':
            if (item.roles[k].role === 'house') {
              keep = true;
            }
            break;
          default:
            break;
        }
      }
      if (keep) {
        out.push(item);
      }
    });
  }
  return out;
}

module.exports = {
  roleType: (input, include = 'pro') => roleType(input, include),
};
